import { IContentBlock } from "contentful-types"
import React, { FC } from "react"
import { DynamicContentMarkdown } from "./DynamicContentMarkdown"
import { DynamicContentComponentProps } from "./DynamicContentComponentProps"

export const ContentBlock: FC<DynamicContentComponentProps<IContentBlock>> = ({ content }) => {
  const {
    fields: { body }
  } = content
  return <DynamicContentMarkdown source={body} />
}
